import React from "react";

import { useIntl } from "react-intl";

import FullPageError from "Components/FullPageError";
import { Link } from "ds/Button";
import useDecodedParams from "Hooks/useDecodedParams";

interface State {
  hasError: boolean;
}
interface Props {
  children: React.ReactNode;
}

class InvitationError extends React.Component<Props, State> {
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    if (error.message === "no-invitation") {
      return { hasError: true };
    }

    throw error;
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}

function ErrorPage() {
  const intl = useIntl();
  const { projectId = "", organizationId = "" } = useDecodedParams<{
    organizationId: string;
    projectId: string;
  }>();
  const accessURL = `/${organizationId}/${projectId}/-/settings/access`;

  const errorTitle = intl.formatMessage({ id: "error_loading_invitation" });
  const errorMessage = intl.formatMessage({
    id: "error_loading_invitation_description"
  });

  return (
    <FullPageError title={errorTitle} message={errorMessage}>
      <div className="actions">
        <Link variant="primary" to={accessURL} analyticId="back+back.access">
          {intl.formatMessage({ id: "back" }) +
            intl.formatMessage({ id: "back.access" })}
        </Link>
      </div>
    </FullPageError>
  );
}

export default InvitationError;
